module.exports = __webpack_public_path__ + "media/buzzerClicked.c874efa6.mp3";